import React from 'react';
import PerformanceDashboard from '../PerformanceDashboard';
import DashboardMobileTabHeader from '../../components/MobileNavigation/DashboardMobileTabHeader';
import { useTheme } from '../../contexts/ThemeContext';
import useIsMobile from '../../hooks/useIsMobile';
import { MOBILE_BOTTOM_NAV_CLEARANCE } from '../../constants/mobileBottomNav';

/** Performance analytics embedded inside DashboardShell. */
export default function DashboardPerformancePage() {
  const isMobile = useIsMobile();
  const { colors } = useTheme();

  if (isMobile) {
    return (
      <div
        style={{
          height: '100dvh',
          display: 'flex',
          flexDirection: 'column',
          paddingTop: 'env(safe-area-inset-top)',
          backgroundColor: colors.bgPrimary,
          overflow: 'hidden',
        }}
      >
        <DashboardMobileTabHeader
          title="Performance"
          menuCurrentPage="dashboard"
          showAccountDropdown
        />
        <div
          style={{
            flex: 1,
            minHeight: 0,
            overflowY: 'auto',
            overflowX: 'hidden',
            padding: `12px 12px ${MOBILE_BOTTOM_NAV_CLEARANCE}`,
          }}
        >
          <PerformanceDashboard hideHeader hideDashboardHeader embeddedMobile />
        </div>
      </div>
    );
  }

  return (
    <div style={{ height: '100%', overflowY: 'auto' }}>
      <PerformanceDashboard
        hideHeader
        hideDashboardHeader
        dashboardTitle="Performance"
      />
    </div>
  );
}
